import { DefaultValidator } from './formValidators.models'

export const withDefaultValidator = (
  translatedValidator: Function,
): DefaultValidator =>
  Object.assign(translatedValidator, { default: translatedValidator() })
